import React, { Component, Fragment } from 'react';
import { Flex, Box, Button, Card, Text } from 'rebass';
import { withWizard } from 'react-albus';
import styled, { css } from 'styled-components';
import { Mutation } from 'react-apollo';

import Select from 'react-select';
import { compose, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications';
import { fadeInDown } from '../../utils/animationsStyleBuilder';
import gql from 'graphql-tag';

const SEND_REASON = gql`
  mutation appendIntakeNoLabChartAlert($noteToAdd: String!) {
    appendIntakeNoLabChartAlert(noteToAdd: $noteToAdd) {
      ok
    }
  }
`;

export const StyledInput = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  flex: 1 0 auto;
  background: ${(props) => (props.disabled ? props.theme.bg.wash : props.theme.bg.default)};
  font-weight: 400;
  font-size: 16px;
  border: 1px solid ${(props) => (props.disabled ? props.theme.bg.border : props.theme.bg.inactive)};
  border-radius: 10px;
  padding: 18px 12px;
  box-shadow: none;
  margin-bottom: 18px;
  ${(props) =>
    props.type === 'checkbox' &&
    css`
      flex: initial;
      width: initial;
      margin-right: 0.5em;
    `} &::placeholder {
    color: ${(props) => props.theme.text.placeholder};
  }
  &::-webkit-input-placeholder {
    color: ${(props) => props.theme.text.placeholder};
  }
  &:-moz-placeholder {
    color: ${(props) => props.theme.text.placeholder};
  }
  &:-ms-input-placeholder {
    color: ${(props) => props.theme.text.placeholder};
  }
  &:focus {
    border-color: ${(props) => props.theme.brand.default};
    outline: none;
  }
  &[type='file'] {
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: hidden;
  }
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
`;

class MedicationPick extends Component {
  constructor(props) {
    super(props);
    this.selects = React.createRef();
    this.noOption = React.createRef();

    this.state = {
      display: false,
      selected: [],
      active: undefined,
      tempValues: {},
    };
  }

  shiftView = () => {
    setTimeout(() => {
      window.scrollTo(0, this.inputRef.offsetTop);
    }, 150);
  };

  render() {
    const { data, onContinue, wizard } = this.props;
    const { selected, active } = this.state;

    const list = data.options
      .sort((a, b) => {
        if (a.label === 'Low Dose Naltrexone') return -1;
        if (b.label === 'Low Dose Naltrexone') return 1;
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })
      .map((x) => {
        return {
          value: x.value,
          label: x.label,
        };
      });
    const noAllergystyle = {
      background: '#FFF2F2',
      border: '2px solid #F6A293',
      borderRadius: '20px',
      margin: '24px auto',
      color: '#344f79',
    };
    const allergyStyle = {
      margin: '24px auto',
    };

    return (
        <Box
          p={3}
          pt={0}
          mb={5}
          mx={3}
          style={{
            zIndex: 1,
            maxWidth: '450px',
            justifyContent: 'center',
            display: 'flex',
            margin: '0 auto',
          }}
        >
        <Mutation mutation={SEND_REASON}>
          {(send, { loading, error }) => (
            <Fragment>
              <Flex flex={1} flexDirection="column">
                <Box m={2} mb={3} style={{ ...fadeInDown() }}>
                  <Text fontSize={'20px'} fontWeight={400} color="#344f77" textAlign="center">
                    {data.prompt}
                  </Text>
                </Box>

                <Select
                  ref={this.selects}
                  components={data.isInputOnly ? { DropdownIndicator: () => null } : {}}
                  style={{ width: '100%' }}
                  classNamePrefix="region-select"
                  options={list}
                  placeholder="Pick a medication"
                  autoFocusOption
                  onChange={(option) => {
                    const sel = selected;
                    sel.push(option);
                    this.setState({
                      active: option,
                      selected: option,
                      tempValues: {},
                    });
                  }}
                  noOptionsMessage={({ inputValue }) => {
                    if (!inputValue) return null;
                    return <NoOptionMessage reff={this.noOption} inputValue={inputValue} onAdd={() => {}} />;
                  }}
                  value={active ? list.filter((element) => element.value === active.value) : null}
                  isSearchable={true}
                />

                {!!selected && selected.value ? (
                  <Button
                    mt={4}
                    alignSelf={'center'}
                    variant={'primary'}
                    style={allergyStyle}
                    onClick={() => {
                      send({
                        variables: {
                          noteToAdd: `Interest in discussing ${selected.value}`,
                        },
                      });
                      onContinue(wizard);
                    }}
                  >
                    Continue
                  </Button>
                ) : (
                  <Button
                    mt={4}
                    alignSelf={'center'}
                    variant={'primary'}
                    style={noAllergystyle}
                    onClick={() => {
                      onContinue(wizard);
                    }}
                  >
                    No, not at this time
                  </Button>
                )}
              </Flex>
            </Fragment>
          )}
        </Mutation>
      </Box>
    );
  }
}

const NoOptionMessage = ({ inputValue, onAdd, reff }) => {
  return (
    <div style={{ padding: '12px 24px' }} ref={reff}>
      <Text textAlign="center" mb={1} fontSize="18px" style={{ cursor: 'not-allowed' }} onClick={onAdd}>
        <span style={{ color: '#364f79' }}> {inputValue}</span>
        <span style={{ color: '#f9a394', fontWeight: '600' }}>{' Not found'}</span>
      </Text>
    </div>
  );
};

class MedicationPickWrap extends Component {
  render() {
    const { data } = this.props;
    return <MedicationPick {...this.props} data={data} />;
  }
}

export default compose(
  withApollo,
  withWizard,
  withToastManager
)(MedicationPickWrap);
